export enum Site {
  GET_SITE_REQUEST = '@site/GET_SITE_REQUEST',
  GET_SITE_SUCCESS = '@site/GET_SITE_SUCCESS',
  GET_SITE_FAIL = '@site/GET_SITE_FAIL',

  GET_SITE_BALANCE_REQUEST = '@site/GET_SITE_BALANCE_REQUEST',
  GET_SITE_BALANCE_SUCCESS = '@site/GET_SITE_BALANCE_SUCCESS',
  GET_SITE_BALANCE_FAIL = '@site/GET_SITE_BALANCE_FAIL',

  CLEAR_SITE = '@site/CLEAR_SITE',

  UPDATE_GRACE_PERIOD_POLICY_REQUEST = '@site/UPDATE_GRACE_PERIOD_POLICY_REQUEST',
  UPDATE_GRACE_PERIOD_POLICY_SUCCESS = '@site/UPDATE_GRACE_PERIOD_POLICY_SUCCESS',
  UPDATE_GRACE_PERIOD_POLICY_FAIL = '@site/UPDATE_GRACE_PERIOD_POLICY_FAIL',

  UPDATE_CREDIT_CARD_FEE_REQUEST = '@site/UPDATE_CREDIT_CARD_FEE_REQUEST',
  UPDATE_CREDIT_CARD_FEE_SUCCESS = '@site/UPDATE_CREDIT_CARD_FEE_SUCCESS',
  UPDATE_CREDIT_CARD_FEE_FAIL = '@site/UPDATE_CREDIT_CARD_FEE_FAIL',

  UPDATE_BUSINESS_DAY_START_REQUEST = '@site/UPDATE_BUSINESS_DAY_START_REQUEST',
  UPDATE_BUSINESS_DAY_START_SUCCESS = '@site/UPDATE_BUSINESS_DAY_START_SUCCESS',
  UPDATE_BUSINESS_DAY_START_FAIL = '@site/UPDATE_BUSINESS_DAY_START_FAIL',

  UPDATE_WITHHOLDINGS_REQUEST = '@site/UPDATE_WITHHOLDINGS_REQUEST',
  UPDATE_WITHHOLDINGS_SUCCESS = '@site/UPDATE_WITHHOLDINGS_SUCCESS',
  UPDATE_WITHHOLDINGS_FAIL = '@site/UPDATE_WITHHOLDINGS_FAIL',

  GENERATE_HEALTH_REPORT_REQUEST = '@site/GENERATE_HEALTH_REPORT_REQUEST',
  GENERATE_HEALTH_REPORT_SUCCESS = '@site/GENERATE_HEALTH_REPORT_SUCCESS',
  GENERATE_HEALTH_REPORT_FAIL = '@site/GENERATE_HEALTH_REPORT_FAIL',

  GENERATE_EMPLOYEE_LIST_REQUEST = '@site/GENERATE_EMPLOYEE_LIST_REQUEST',
  GENERATE_EMPLOYEE_LIST_SUCCESS = '@site/GENERATE_EMPLOYEE_LIST_SUCCESS',
  GENERATE_EMPLOYEE_LIST_FAIL = '@site/GENERATE_EMPLOYEE_LIST_FAIL',

  PROCESS_ONBOARDING_EMPLOYEES_REQUEST = '@site/PROCESS_ONBOARDING_EMPLOYEES_REQUEST',
  PROCESS_ONBOARDING_EMPLOYEES_SUCCESS = '@site/PROCESS_ONBOARDING_EMPLOYEES_SUCCESS',
  PROCESS_ONBOARDING_EMPLOYEES_FAIL = '@site/PROCESS_ONBOARDING_EMPLOYEES_FAIL',
}
